module.exports = "pegasus_template/assets/theme4/facebook-icon.png";